import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_CONFIRM_MOVE_IN } from 'api/actionTypes';

import { SCREEN_ID_HOUSEHOLD_CONFIRM_MOVE_IN } from 'client/constants/screenIds';

import withApiState from 'client/helpers/withApiState';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDatePicker from 'client/components/SrDatePicker';
import HouseholdActions from 'client/actions/Household';
import UserActions from 'client/actions/User';
import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';

import branch from 'client/core/branch';

@withTransitionHook
@withScrollToTop
@withApiState({
  updateMoveInDateApiState: {
    action: SR_API_ACTION_CONFIRM_MOVE_IN,
  },
})
@branch({
  currentUser: ['currentUser'],
})
@withScreenId(SCREEN_ID_HOUSEHOLD_CONFIRM_MOVE_IN)
class HouseholdConfirmMoveIn extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Invite Roommates to Apply | Sunroom Rentals',
    section: 'When would you like to move?',
  });

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this._onConfirmMoveInDateFormSubmit = this._onConfirmMoveInDateFormSubmit.bind(this);

    this.state = {
      moveInInput: new Date(props.currentUser.moveInDate) || '',
    };
  }

  async _onConfirmMoveInDateFormSubmit() {
    const { match, dispatch } = this.props;

    const { moveInInput } = this.state;

    await dispatch(UserActions.updateMoveInDate, {
      moveInDate: moveInInput,
    });

    await dispatch(HouseholdActions.roommateApplicationStep, {
      tourId: parseInt(match.params.tourId, 10),
      listingId: parseInt(match.params.listingId, 10),
    });
  }

  _onHandleSubmitForm = (event) => {
    event.preventDefault();
    this._onConfirmMoveInDateFormSubmit();
  };

  _onChange = (event) => {
    const value = event && event.toDate ? event.toDate() : '';

    this.setState({
      moveInInput: value,
    });
  };

  render() {
    const { updateMoveInDateApiState } = this.props;

    const { moveInInput } = this.state;

    const isDisabled = !moveInInput || updateMoveInDateApiState.inProgress;

    return (
      <div className="page-inviteRoommates">
        <div className="inviteRoommates">
          <Navbar
            leftButton={
              <SrLink
                className="link back"
                restoreScrollPosition
                redirectToLastLocation
                to="/tour"
              />
            }
          />
          <div className="stepContainer">
            <div className="textContainer">
              <h1>When would you like to move?</h1>
            </div>
            <div className="formContainer answers">
              <form method="post" onSubmit={this._onHandleSubmitForm}>
                <SrDatePicker
                  className="choice datePicker"
                  isValidDate={(current) => current.isAfter(new Date())}
                  onChange={this._onChange}
                  value={moveInInput || ''}
                  placeholder="Choose date..."
                  closeOnSelect
                  readOnly
                />
                <ButtonDeprecated
                  type="submit"
                  onClick={this._onHandleSubmitForm}
                  disabled={isDisabled || updateMoveInDateApiState.inProgress}
                >
                  next
                </ButtonDeprecated>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HouseholdConfirmMoveIn.displayName = 'HouseholdConfirmMoveIn';

export default HouseholdConfirmMoveIn;
